import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  const footerLinks = {
    kurumsal: [
      { name: t('footer.aboutUs'), href: '#kurumsal' },
      { name: t('about.mission.title'), href: '#kurumsal' },
      { name: t('about.vision.title'), href: '#kurumsal' },
      { name: t('about.values.title'), href: '#kurumsal' }
    ],
    urunler: [
      { name: t('products.items.weapons.title'), href: '#products' },
      { name: t('products.items.armored.title'), href: '#products' },
      { name: t('products.items.explosives.title'), href: '#products' },
      { name: t('products.items.cyber.title'), href: '#products' }
    ],
    iletisim: [
      { name: '+90 532 415 5992', href: 'tel:+905324155992' },
      { name: 'info@symbasecuretech.com', href: 'mailto:info@symbasecuretech.com' },
      { name: 'Çankaya/Ankara', href: '#contact' }
    ]
  };

  const socialLinks = [
    { name: 'LinkedIn', icon: '🔗', href: '#' },
    { name: 'Twitter', icon: '🐦', href: '#' },
    { name: 'Facebook', icon: '📘', href: '#' }
  ];

  return (
    <footer className="footer-section">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Logo ve Açıklama */}
            <motion.div 
              className="footer-brand"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="footer-logo-wrapper">
                <img src="/tarvexnew.png" alt="TARVEX DEFENCE SYSTEMS" className="footer-logo-img" />
              </div>
              <p className="footer-description">
                {t('footer.description')}
              </p>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a 
                    key={index}
                    href={social.href}
                    className="social-link"
                    aria-label={social.name}
                  >
                    <span>{social.icon}</span>
                  </a>
                ))}
              </div>
            </motion.div>

            {/* Kurumsal Linkler */}
            <motion.div 
              className="footer-column"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <h4>{t('footer.corporate')}</h4>
              <ul>
                {footerLinks.kurumsal.map((link, index) => (
                  <li key={index}>
                    <a href={link.href}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Ürünler */}
            <motion.div 
              className="footer-column"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h4>{t('footer.ourProducts')}</h4>
              <ul>
                {footerLinks.urunler.map((link, index) => (
                  <li key={index}>
                    <a href={link.href}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* İletişim */}
            <motion.div 
              className="footer-column"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <h4>{t('contact.title')}</h4>
              <ul className="contact-list">
                {footerLinks.iletisim.map((link, index) => (
                  <li key={index}>
                    <a href={link.href}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Alt Footer */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} SymbasecureTech. {t('footer.rights')}</p>
            <div className="footer-bottom-links">
              <a href="#privacy">{t('footer.privacy')}</a>
              <span className="separator">|</span>
              <a href="#terms">{t('footer.terms')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;